import { defaultIconProps } from 'components/common/icons'
import type { DefaultIconProps } from 'components/common/icons'

export const Clock = ({
  size = defaultIconProps.size,
  className = defaultIconProps.className,
}: DefaultIconProps) => (
  <svg
    width={size}
    height={size && size * 0.9}
    viewBox="0 0 97 96"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.5 5C24.7518 5 5.5 24.2518 5.5 48C5.5 71.7484 24.7518 91 48.5 91C72.2484 91 91.5 71.7484 91.5 48C91.5 24.2518 72.2484 5 48.5 5ZM52.5 32C52.5 29.7909 50.7092 28 48.5 28C46.2908 28 44.5 29.7909 44.5 32V48C44.5 49.0608 44.9216 50.0784 45.6716 50.8284L53.6716 58.8284C55.2336 60.3904 57.7664 60.3904 59.3284 58.8284C60.8904 57.2664 60.8904 54.7336 59.3284 53.1716L52.5 46.3432V32Z"
    />
  </svg>
)
